// Module 04 — static locale metadata (contract 04 §5).
// The ONLY registry: adding a language is a row here + a dropped JSON set (the glob loader
// discovers the files). No loader/registry edit is required.
import type { LocaleMeta, SupportedLocale } from './types'

export const DEFAULT_LOCALE: SupportedLocale = 'en'

export const SUPPORTED_LOCALES: readonly SupportedLocale[] = ['en']

export const localeMeta: Record<SupportedLocale, LocaleMeta> = {
  en: { code: 'en', intl: 'en-US', label: 'English', dir: 'ltr', defaultCurrency: 'USD' },
  // ar: { code: 'ar', intl: 'ar', label: 'العربية', dir: 'rtl', defaultCurrency: 'AED' } // RTL drop-in
}
